import { fetchPost } from '~utilities/fetch';

export async function addressSearchRequest(keyword: string): Promise<Response> {
    return fetchPost('/address-search', { keyword });
}
